// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import type { EntityState } from '@reduxjs/toolkit';

/**
 * `object_type` values for tag assignments (Engine tag APIs). Add new domain
 * objects here; use enum members instead of string literals.
 */
export enum TagObjectType {
  Account = 'ACCOUNT',
  IlliquidAsset = 'ILLIQUID_ASSET',
}

export interface RootTagsManagementState {
  readonly tagsManagement: TagsManagementState;
}

export interface TagsManagementState {
  readonly tags: EntityState<TagEntity, number>;
  readonly assignments: EntityState<TagAssignmentEntity, string>;
}

export interface TagEntity {
  readonly tag_id: number;
  readonly name: string;
}

export interface TagAssignmentEntity {
  readonly object_type: string;
  readonly object_id: string;
  readonly tag_ids: readonly number[];
}

/**
 * The key is the object type and the object id concatenated with a colon.
 *
 * @example
 *
 * ```ts
 * `${TagObjectType.Account}:ES1234567890`;
 * ```
 */
export type TagsByObjectKey = `${string}:${string}`;

export interface TagsByObjectEntry {
  readonly id: string;
  readonly type: string;
  readonly tags: readonly TagEntity[];
}
